import { Dispatch, SetStateAction } from 'react';
import { Wallet } from 'interfaces';
import { API } from '../../data/30pay.api';
import { get } from 'scripts';

export const getWallet = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Wallet | undefined>>,
) => {
    setLoading(true);
    await get<Wallet>(API.wallet.mine)
        .then((response) => {
            setData(response.value.value);
        })
        .catch((error) => console.log(error))
        .finally(() => setLoading(false));

};